export { default } from './BlogArticle.container'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Blog/BlogArticle/index.js